import { Button } from '@lego/connect-components-react';
import { useLocation, useNavigate } from 'react-router-dom';

export const NotFoundPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] mx-auto my-200 gap-150 text-center">
      <h1 className="text-heading-3xl font-brand font-bold text-core-blue-900">
        🧭 Page Not Found
      </h1>
      <p className="text-body-md text-core-slate-1100 max-w-prose">
        We couldn't find <code className="text-core-blue-800 break-all">{location.pathname}</code>.
        It may have been moved, renamed, or never existed.
      </p>
      <Button size="small" variant="primary" onClick={() => navigate('/')}>
        🏠 Go back home
      </Button>
    </div>
  );
};
